import React, { Component } from 'react';
import marked from "marked";


class Home extends Component {

  constructor(props) {
    super(props);
    this.state = { markdown: "" }
  }
  
  componentWillMount() {
    const introPath = require("../intro.md");
    console.log(introPath);
    fetch(introPath)
      .then(response=>{
        return response.text()
      })
      .then(text=>{
        this.setState({
          markdown: marked(text)
        })
      })
  }

  render() {
    const { markdown } = this.state;
    return (
      <div className="intro">
        <section>
          <article dangerouslySetInnerHTML={{__html: markdown}}></article>
        </section>
      </div>
    )
  }
}


export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js